import $ from "jquery";
import { config } from './../config';
const Log = function (param) {
  if (config.debug) {
    console.log(param);
  }
};
const browsers = {
  whichBrowser : function (options){
    var inBrowser = typeof window !== 'undefined' && Object.prototype.toString.call(window) !== '[object Object]';
    // Log([inBrowser]);
    var UA = inBrowser && window.navigator.userAgent.toLowerCase();
    // Log([UA]);
    var theBrowsers = {
      isIE : UA && UA.indexOf('trident') > 0,
      isIE9 : UA && UA.indexOf('msie 9.0') > 0,
      isAndroid : UA && UA.indexOf('android') > 0,
      isIOS : UA && /iphone|ipad|ipod|ios/.test(UA),
      isFirefox : UA && UA.indexOf('firefox') > 0,
      isChrome : UA && UA.indexOf('chrome') > 0,
      isSafari :   UA && UA.indexOf('safari/') > 0 && UA.indexOf('chrome/') < 0
    };
    Log([theBrowsers]);

    return theBrowsers;
  }
};

export { browsers };
